import { Directive, ElementRef, HostListener, Input, Output, EventEmitter, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Directive({ selector: '[dLazyLoad]' })
export class LazyLoadDirective implements OnDestroy, OnChanges {

  // å¯ç¨æå è½½ï¼é»è®¤ä¸å¯ç¨
  @Input() enableLazyLoad = false;
  // å è½½æ´å¤
  @Output() loadMore = new EventEmitter();

  scrollSubscription: Subscription;

  // è§¦åæå è½½çè·ç¦»
  loadFactor = 5;

  constructor(private el: ElementRef) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['enableLazyLoad']) {
      if (changes.enableLazyLoad.currentValue) {
        this.scrollSubscription = fromEvent(this.el.nativeElement, 'scroll').pipe(
          debounceTime(300),
          distinctUntilChanged()
        ).subscribe(event => this.scrollList(event));
      } else if (this.scrollSubscription) {
        this.scrollSubscription.unsubscribe();
      } else {
        return;
      }
    }
  }
  ngOnDestroy() {
    if (this.scrollSubscription) {
      this.scrollSubscription.unsubscribe();
    }
  }

  scrollList(event) {
    const targetEl = event.target;
    const clientHeight = targetEl.clientHeight;
    const scrollHeight = targetEl.scrollHeight;
    const scrollTop = targetEl.scrollTop;
    if (scrollTop !== 0 && (scrollTop + clientHeight + this.loadFactor >= scrollHeight)) {
      this.loadMore.emit(event);
    }

  }
}
